import React from 'react';
import PropTypes from 'prop-types';

const LoginHeader = ({ rightContent, title }) => {
    return (
        <div className="cell shrink cell-block-container tx-kiosk__header">
            <div className="grid-x grid-padding-y align-middle">
                <div className="cell small-6">
                    <h1 className="tx-kiosk__title">{title}</h1>
                </div>
                <div className="cell small-6 align-right">
                    {rightContent}
                </div>
            </div>
        </div>
    );
};

export default LoginHeader;

LoginHeader.propTypes = {
    rightContent: PropTypes.any,
    title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/LoginHeader/LoginHeader.jsx